(function () {
  'use strict';

  var headerInstance = null;

  function initAxiomHeader(root, forceRebuild) {
    var scope = root && root.querySelector ? root : document;
    var header = scope.querySelector('[data-header]') || document.querySelector('[data-header]');
    if (!header) return;

    if (window.Axiom && typeof window.Axiom.mountHeaderMegaMenus === 'function') {
      window.Axiom.mountHeaderMegaMenus(header.closest('.shopify-section') || document);
    }

    if (!forceRebuild && headerInstance && headerInstance.header === header) {
      if (typeof headerInstance.syncSidebar === 'function') {
        headerInstance.syncSidebar();
      }
      return;
    }
    if (headerInstance && typeof headerInstance.destroy === 'function') {
      headerInstance.destroy();
    }

    headerInstance = createHeaderInstance(header);
  }

  function createHeaderInstance(header) {
    var cleanups = [];
    var timeoutIds = new Set();
    var frameIds = new Set();
    var dropdownOpenBehavior = header.dataset.dropdownOpen || 'hover';
    var headerSticky = window.Axiom && typeof window.Axiom.mountHeaderSticky === 'function'
      ? window.Axiom.mountHeaderSticky(header)
      : null;
    var hamburger = header.querySelector('[data-hamburger]');
    var drawer = document.getElementById('mobileDrawer');
    var desktopSidebar = null;
    var overlay = document.getElementById('site-overlay');
    var searchTriggers = Array.prototype.slice.call(header.querySelectorAll('[data-open-search]'));
    var searchTrigger = searchTriggers[0] || null;
    var wideSearchInput = header.querySelector('[data-wide-search-input]');
    var searchPanel = document.getElementById('searchPanel');
    var searchInput = document.getElementById('searchPanelInput');
    var predictiveForm = searchPanel && searchPanel.querySelector('[data-predictive-search-form]');
    var predictiveResults = searchPanel && searchPanel.querySelector('[data-predictive-results]');
    var wideSearchForm = wideSearchInput && wideSearchInput.closest('form');
    var widePredictiveResults = wideSearchForm && wideSearchForm.querySelector('[data-predictive-results]');
    var activePredictiveInput = searchInput;
    var activePredictiveForm = predictiveForm;
    var activePredictiveResults = predictiveResults;
    var closeSearchBtn = document.querySelector('[data-close-search]');
    var desktopDropdownItems = Array.prototype.slice.call(header.querySelectorAll('.nav-links__item--has-dropdown'));
    var predictiveTimer = null;
    var predictiveRequestController = null;
    var predictiveRequestId = 0;
    var lastInputWasKeyboard = false;
    var mobileAccordionDuration = 620;
    var panelDuration = 620;
    var desktopDropdownDuration = 260;
    var hasOpenDesktopDropdown = false;
    var headerPanelOpen = false;

    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'false');
    }
    syncDesktopSidebarState();
    document.body.classList.remove('desktop-sidebar-open');
    if (desktopSidebar) {
      desktopSidebar.classList.remove('is-open', 'is-settled', 'is-panel-open', 'is-panel-opening', 'is-panel-closing');
      desktopSidebar.setAttribute('aria-hidden', 'true');
    }

    function trackTimeout(callback, delay) {
      var id = window.setTimeout(function () {
        timeoutIds.delete(id);
        callback();
      }, delay);
      timeoutIds.add(id);
      return id;
    }

    function clearTrackedTimeout(id) {
      if (!id) return;
      window.clearTimeout(id);
      timeoutIds.delete(id);
    }

    function clearAllTrackedTimeouts() {
      timeoutIds.forEach(function (id) {
        window.clearTimeout(id);
      });
      timeoutIds.clear();
    }

    function trackFrame(callback) {
      var id = window.requestAnimationFrame(function () {
        frameIds.delete(id);
        callback();
      });
      frameIds.add(id);
      return id;
    }

    function clearAllTrackedFrames() {
      frameIds.forEach(function (id) {
        window.cancelAnimationFrame(id);
      });
      frameIds.clear();
    }

    function on(target, eventName, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      target.addEventListener(eventName, handler, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    var mobileHeaderQuery = window.matchMedia('(max-width: 767px)');

    function syncHamburgerPosition() {
      if (!hamburger) return;
      var navInner = header.querySelector('.nav-inner');
      var navActions = header.querySelector('.nav-actions');
      var navLogo = header.querySelector('.nav-logo');
      if (!navInner || !navActions || !navLogo) return;

      // Keep DOM/focus order aligned with the selected layout at each breakpoint.
      var placeRight = mobileHeaderQuery.matches
        ? header.classList.contains('nav--mobile-layout-logo_left_burger_right')
        : header.classList.contains('nav--burger-position-right');
      if (placeRight && hamburger.parentElement !== navActions) {
        navActions.appendChild(hamburger);
      } else if (!placeRight && hamburger.parentElement !== navInner) {
        navInner.insertBefore(hamburger, navLogo);
      }
    }

    syncHamburgerPosition();
    on(mobileHeaderQuery, 'change', syncHamburgerPosition);

    function syncHeaderHeight() {
      if (headerSticky && typeof headerSticky.sync === 'function') headerSticky.sync();
    }

    function hydrateDeferredContent(scope, hostSelector, templateSelector) {
      if (!scope) return;
      var host = scope.querySelector(hostSelector);
      var template = scope.querySelector(templateSelector);
      if (!host || !template) return;
      host.replaceWith(template.content.cloneNode(true));
      template.remove();
    }

    function getDesktopSidebar() {
      return document.getElementById('desktopSidebarMenu');
    }

    function syncDesktopSidebarState(shouldBind) {
      desktopSidebar = getDesktopSidebar();
      if (shouldBind) bindDesktopSidebarElement(desktopSidebar);
      return desktopSidebar;
    }

    function revealOpenGroup(group, options) {
      if (!group || !window.Axiom || typeof window.Axiom.revealElements !== 'function') return;
      window.Axiom.revealElements(group, Object.assign({
        trigger: 'open',
        reset: true
      }, options || {}));
    }

    function bindDesktopSidebarElement(sidebar) {
      if (!sidebar || sidebar.dataset.headerSidebarBound === 'true') return;
      sidebar.dataset.headerSidebarBound = 'true';

      var sidebarInner = sidebar.querySelector('.desktop-sidebar__inner');
      if (sidebarInner) {
        on(sidebarInner, 'transitionend', function (event) {
          if (
            event.target === sidebarInner &&
            event.propertyName === 'transform' &&
            sidebar.classList.contains('is-open')
          ) {
            sidebar.classList.add('is-settled');
          }
        });
      }

      var nestedContainer = sidebar.querySelector('[data-sidebar-nested-container]');
      if (nestedContainer) {
        sidebar.querySelectorAll('.desktop-sidebar__inner [data-sidebar-panel]').forEach(function (panel) {
          nestedContainer.appendChild(panel);
        });
      }

      on(sidebar, 'click', function (event) {
        if (event.target === sidebar) {
          closeDesktopSidebar();
        }
      });

      sidebar.querySelectorAll('[data-sidebar-panel-open]').forEach(function (button) {
        on(button, 'click', function () {
          if (button.getAttribute('aria-expanded') === 'true') {
            closeSidebarPanels(sidebar);
          } else {
            openSidebarPanel(sidebar, button);
          }
        });
      });

      sidebar.querySelectorAll('[data-sidebar-panel-close]').forEach(function (button) {
        on(button, 'click', function () {
          closeSidebarPanels(sidebar, { focusTrigger: true });
        });
      });
    }

    function usesSidebar() {
      return Boolean(syncDesktopSidebarState());
    }

    function syncHamburgerTarget() {
      if (!hamburger) return;
      hamburger.setAttribute('aria-controls', usesSidebar() ? 'desktopSidebarMenu' : 'mobileDrawer');
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (character) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
      });
    }

    function getPredictiveImageData(item) {
      if (!item) return null;

      var candidates = [
        item.image,
        item.featured_image,
        item.featured_media && item.featured_media.preview_image,
        item.preview_image
      ];

      for (var index = 0; index < candidates.length; index += 1) {
        var candidate = candidates[index];
        if (!candidate) continue;

        if (typeof candidate === 'string') {
          return {
            src: candidate,
            alt: item.title || ''
          };
        }

        if (candidate.url || candidate.src) {
          return {
            src: candidate.url || candidate.src,
            alt: candidate.alt || item.title || ''
          };
        }
      }

      return null;
    }

    function getPredictiveImageUrl(source, width) {
      if (!source) return '';

      try {
        var url = new URL(source, window.location.href);
        url.searchParams.set('width', String(width));
        return url.toString();
      } catch (error) {
        var separator = source.indexOf('?') === -1 ? '?' : '&';
        return source + separator + 'width=' + width;
      }
    }

    function hidePredictiveResults() {
      if (!activePredictiveResults) return;
      activePredictiveResults.classList.remove('is-visible');
      activePredictiveResults.innerHTML = '';
      refreshSearchFocusTrap();
    }

    function activatePredictiveSearch(input, form, results) {
      abortPredictiveRequest();
      hidePredictiveResults();
      activePredictiveInput = input;
      activePredictiveForm = form;
      activePredictiveResults = results;
    }

    function refreshSearchFocusTrap() {
      if (!searchPanel || !isSearchOpen()) return;
      if (window.Axiom && typeof window.Axiom.releaseFocus === 'function' && typeof window.Axiom.trapFocus === 'function') {
        window.Axiom.releaseFocus(searchPanel);
        window.Axiom.trapFocus(searchPanel, { autofocus: false });
      }
    }

    function renderPredictiveResults(resources) {
      if (!activePredictiveResults) return;

      var products = (resources && resources.products) || [];
      var collections = (resources && resources.collections) || [];
      var articles = (resources && resources.articles) || [];
      var pages = (resources && resources.pages) || [];
      var items = products.map(function (item) { return { item: item, resourceType: 'product' }; })
        .concat(collections.map(function (item) { return { item: item, resourceType: 'collection' }; }))
        .concat(articles.map(function (item) { return { item: item, resourceType: 'article' }; }))
        .concat(pages.map(function (item) { return { item: item, resourceType: 'page' }; }))
        .slice(0, 8);

      if (!items.length) {
        activePredictiveResults.classList.add('is-visible');
        var emptyMessage = activePredictiveResults.dataset.emptyMessage || '';
        activePredictiveResults.innerHTML = '<p class="predictive-search__empty">' + escapeHtml(emptyMessage) + '</p>';
        refreshSearchFocusTrap();
        return;
      }

      activePredictiveResults.classList.add('is-visible');
      activePredictiveResults.innerHTML = '<div class="predictive-search__grid">' + items.map(function (entry) {
        var item = entry.item;
        var resourceType = entry.resourceType;
        var image = getPredictiveImageData(item);
        var imageHtml = image && image.src
          ? '<img src="' + escapeHtml(getPredictiveImageUrl(image.src, 640)) + '" srcset="' + [320, 480, 640, 800, 960].map(function (width) {
              return escapeHtml(getPredictiveImageUrl(image.src, width)) + ' ' + width + 'w';
            }).join(', ') + '" sizes="(max-width: 767px) calc((100vw - 54px) / 2), (max-width: 1760px) calc((100vw - 122px) / 4), 414px" width="400" height="533" alt="' + escapeHtml(image.alt || item.title) + '" loading="lazy" decoding="async">'
          : '<span class="predictive-search__placeholder" aria-hidden="true"></span>';
        var type = resourceType === 'product' ? (item.type || resourceType) : resourceType;
        var showTitle = resourceType === 'product'
          ? activePredictiveForm.dataset.predictiveShowProductTitles !== 'false'
          : resourceType === 'collection'
            ? activePredictiveForm.dataset.predictiveShowCollectionTitles !== 'false'
            : true;
        return '<a class="predictive-search__item predictive-search__item--' + resourceType + '" href="' + escapeHtml(item.url) + '">' +
          imageHtml +
          (showTitle ? '<span class="predictive-search__title">' + escapeHtml(item.title) + '</span>' : '') +
          (type ? '<span class="predictive-search__meta">' + escapeHtml(type) + '</span>' : '') +
          '</a>';
      }).join('') + '</div>';
      refreshSearchFocusTrap();
    }

    function abortPredictiveRequest() {
      predictiveRequestId += 1;
      if (!predictiveRequestController) return;
      predictiveRequestController.abort();
      predictiveRequestController = null;
    }

    function fetchPredictiveResults(query) {
      if (!activePredictiveForm || activePredictiveForm.dataset.predictiveEnabled !== 'true') return;
      if (!query || query.length < 2) {
        abortPredictiveRequest();
        hidePredictiveResults();
        return;
      }

      var resources = activePredictiveForm.dataset.predictiveType || 'product,article,page';
      var shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        || (window.Axiom && window.Axiom.routes && window.Axiom.routes.root)
        || '/';
      var base = (window.Axiom && window.Axiom.routes && window.Axiom.routes.predictive_search)
        || shopifyRoot + 'search/suggest';
      var url = base + '.json?q=' + encodeURIComponent(query) + '&resources[type]=' + encodeURIComponent(resources) + '&resources[limit]=8';
      var requestId = predictiveRequestId + 1;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;

      abortPredictiveRequest();
      predictiveRequestId = requestId;
      predictiveRequestController = controller;

      fetch(url, {
        headers: { 'Accept': 'application/json' },
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          return response.ok ? response.json() : { resources: { results: {} } };
        })
        .then(function (data) {
          if (requestId !== predictiveRequestId) return;
          if (activePredictiveInput && activePredictiveInput.value.trim() !== query) return;
          renderPredictiveResults(data.resources && data.resources.results);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (requestId !== predictiveRequestId) return;
          hidePredictiveResults();
        })
        .finally(function () {
          if (predictiveRequestController === controller) {
            predictiveRequestController = null;
          }
        });
    }

    function isDesktopSidebarOpen() {
      var sidebar = syncDesktopSidebarState();
      return Boolean(sidebar && sidebar.getAttribute('aria-hidden') === 'false');
    }

    function isMobileDrawerOpen() {
      return Boolean(drawer && drawer.getAttribute('aria-hidden') === 'false');
    }

    function isSearchOpen() {
      return Boolean(searchPanel && searchPanel.getAttribute('aria-hidden') === 'false');
    }

    function isHeaderPanelOpen() {
      return Boolean(
        isMobileDrawerOpen() ||
        isDesktopSidebarOpen() ||
        isSearchOpen() ||
        document.querySelector('.nav-links__item--has-dropdown.is-open')
      );
    }

    function isHeaderCompactBlocked() {
      return Boolean(
        isMobileDrawerOpen() ||
        isDesktopSidebarOpen() ||
        isSearchOpen()
      );
    }

    function syncHeaderMenuState() {
      headerPanelOpen = isHeaderPanelOpen();
      header.classList.toggle('nav--menu-open', headerPanelOpen);
      header.classList.toggle('nav--compact-blocked', isHeaderCompactBlocked());
      syncMegaMenuBackdrop();
      syncHeaderHeight();
    }

    function syncMegaMenuBackdrop() {
      if (!overlay) return;

      var hasOpenMegaMenu = desktopDropdownItems.some(function (item) {
        return item.classList.contains('is-open') && getDesktopDropdownPanels(item).length > 0;
      });

      overlay.classList.toggle('overlay--mega-menu-active', hasOpenMegaMenu);
      if (hasOpenMegaMenu && headerSticky) headerSticky.syncOverlayTop();
    }

    function setHeaderPanelPreviewState(isOpen) {
      headerPanelOpen = Boolean(isOpen);
      header.classList.toggle('nav--menu-open', headerPanelOpen);
      header.classList.toggle('nav--compact-blocked', headerPanelOpen);
      syncHeaderHeight();
    }

    function getSidebarPanelHostStateClass(host) {
      if (!host) return '';
      return host === drawer ? 'is-mega-panel-open' : 'is-panel-open';
    }

    function isDesktopSidebarHost(host) {
      return Boolean(syncDesktopSidebarState() && host === desktopSidebar);
    }

    function getSidebarPanel(host, panelId) {
      if (!host || !panelId) return null;
      return host.querySelector('[data-sidebar-panel="' + panelId + '"]');
    }

    function setSidebarPanelHidden(panel, hidden) {
      if (!panel) return;
      panel.hidden = hidden;
      panel.classList.toggle('is-active', !hidden);
      panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    }

    function closeSidebarPanels(host, options) {
      if (!host) return;

      options = options || {};
      clearTrackedTimeout(host._panelCloseTimer);
      clearTrackedTimeout(host._panelOpenTimer);
      host._panelCloseTimer = null;
      host._panelOpenTimer = null;
      if (host._panelTransitionEndHandler && host._panelTransitionEndTarget) {
        host._panelTransitionEndTarget.removeEventListener('transitionend', host._panelTransitionEndHandler);
        host._panelTransitionEndHandler = null;
        host._panelTransitionEndTarget = null;
      }

      var activePanel = host.querySelector('[data-sidebar-panel].is-active');
      var activePanelId = activePanel ? activePanel.getAttribute('data-sidebar-panel') : '';
      var activeTrigger = activePanelId ? host.querySelector('[data-sidebar-panel-target="' + activePanelId + '"]') : null;
      var hostStateClass = getSidebarPanelHostStateClass(host);
      var immediate = Boolean(options.immediate);
      var desktopSidebarHost = isDesktopSidebarHost(host);
      host.classList.remove(hostStateClass);
      host.classList.remove('is-panel-open');
      if (desktopSidebarHost) {
        host.classList.remove('is-panel-opening');
        if (!immediate && activePanel) {
          host.classList.add('is-panel-closing');
        } else {
          host.classList.remove('is-panel-closing');
        }
      }

      host.querySelectorAll('[data-sidebar-panel-open][aria-expanded="true"]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });

      function hidePanels() {
        host.querySelectorAll('[data-sidebar-panel]').forEach(function (panel) {
          setSidebarPanelHidden(panel, true);
        });
        if (desktopSidebarHost) {
          host.classList.remove('is-panel-closing');
        }
      }

      if (!activePanel || immediate) {
        hidePanels();
      } else {
        host._panelCloseTimer = trackTimeout(function () {
          hidePanels();
          host._panelCloseTimer = null;
        }, panelDuration + 40);
      }

      if (activeTrigger && options.focusTrigger) {
        activeTrigger.focus();
      }
    }

    function openSidebarPanel(host, trigger) {
      if (!host || !trigger) return;

      clearTrackedTimeout(host._panelCloseTimer);
      clearTrackedTimeout(host._panelOpenTimer);
      host._panelCloseTimer = null;
      host._panelOpenTimer = null;
      if (host._panelTransitionEndHandler && host._panelTransitionEndTarget) {
        host._panelTransitionEndTarget.removeEventListener('transitionend', host._panelTransitionEndHandler);
        host._panelTransitionEndHandler = null;
        host._panelTransitionEndTarget = null;
      }

      var panelId = trigger.getAttribute('data-sidebar-panel-target') || trigger.getAttribute('aria-controls');
      var panel = getSidebarPanel(host, panelId);
      if (!panel) return;
      var desktopSidebarHost = isDesktopSidebarHost(host);
      var currentPanel = host.querySelector('[data-sidebar-panel].is-active');

      if (desktopSidebarHost && currentPanel && currentPanel !== panel) {
        host.classList.remove('is-panel-open', 'is-panel-opening', 'is-panel-closing');
      }

      host.querySelectorAll('[data-sidebar-panel]').forEach(function (item) {
        if (item !== panel) setSidebarPanelHidden(item, true);
      });

      host.querySelectorAll('[data-sidebar-panel-open]').forEach(function (item) {
        item.setAttribute('aria-expanded', String(item === trigger));
      });

      setSidebarPanelHidden(panel, false);
      if (desktopSidebarHost) {
        host.classList.remove('is-panel-closing');
      }

      window.requestAnimationFrame(function () {
        if (desktopSidebarHost) {
          host.classList.add('is-panel-opening');
        }
        host.classList.add(getSidebarPanelHostStateClass(host));
        host.classList.add('is-panel-open');
        revealOpenGroup(panel);
        if (desktopSidebarHost) {
          host._panelOpenTimer = trackTimeout(function () {
            host.classList.remove('is-panel-opening');
            host._panelOpenTimer = null;
          }, panelDuration);
        }

      });
    }

    function closeAllDesktopDropdowns() {
      hasOpenDesktopDropdown = false;
      desktopDropdownItems.forEach(function (item) {
        item.classList.remove('is-open');
        clearMegaMenuHoverBridge(item);
        hideDesktopDropdownPanels(item);
        var trigger = item.querySelector('[data-dropdown-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      syncHeaderMenuState();
    }

    function getDesktopDropdownPanels(item) {
      if (!item || !item.querySelectorAll) return [];
      return Array.prototype.slice.call(item.querySelectorAll('[data-axiom-mega-rows]'));
    }

    function syncMegaMenuHoverBridge(item) {
      if (!item) return;

      var itemRect = item.getBoundingClientRect();
      getDesktopDropdownPanels(item).forEach(function (panel) {
        var panelRect = panel.getBoundingClientRect();
        var gap = Math.max(0, panelRect.top - itemRect.bottom);

        panel.style.setProperty('--mega-menu-hover-bridge-height', Math.ceil(gap) + 'px');
        panel.toggleAttribute('data-mega-hover-bridge', gap > 0.5);
      });
    }

    function clearMegaMenuHoverBridge(item) {
      getDesktopDropdownPanels(item).forEach(function (panel) {
        panel.style.removeProperty('--mega-menu-hover-bridge-height');
        panel.removeAttribute('data-mega-hover-bridge');
      });
    }

    function getSimpleDesktopDropdown(item) {
      if (!item || item.classList.contains('nav-links__item--has-mega')) return null;
      var panel = item.querySelector('[data-nav-dropdown-fallback]');
      return panel && !panel.hidden ? panel : null;
    }

    function positionSimpleDesktopDropdown(item, panel) {
      var trigger = item && item.querySelector('[data-dropdown-trigger]');
      if (!trigger || !panel) return;

      var triggerRect = trigger.getBoundingClientRect();
      var viewportPadding = 8;
      var panelWidth = panel.getBoundingClientRect().width;
      var isRtl = document.documentElement.dir === 'rtl';
      var inlineStart = isRtl ? triggerRect.right - panelWidth : triggerRect.left;
      var maximumInlineStart = Math.max(viewportPadding, window.innerWidth - panelWidth - viewportPadding);

      inlineStart = Math.min(Math.max(inlineStart, viewportPadding), maximumInlineStart);
      panel.style.setProperty('--nav-dropdown-block-start', Math.round(triggerRect.bottom) + 'px');
      panel.style.setProperty('--nav-dropdown-inline-start', Math.round(inlineStart) + 'px');
    }

    function showSimpleDesktopDropdown(item) {
      var panel = getSimpleDesktopDropdown(item);
      if (!panel) return;

      if (panel._simpleDropdownHideTimer) {
        clearTrackedTimeout(panel._simpleDropdownHideTimer);
        panel._simpleDropdownHideTimer = null;
      }
      if (typeof panel.showPopover === 'function') {
        panel.setAttribute('popover', 'manual');
        if (!panel.matches(':popover-open')) panel.showPopover();
      }
      panel.setAttribute('aria-hidden', 'false');
      positionSimpleDesktopDropdown(item, panel);
    }

    function hideSimpleDesktopDropdown(item) {
      var panel = getSimpleDesktopDropdown(item);
      if (!panel) return;

      if (panel._simpleDropdownHideTimer) {
        clearTrackedTimeout(panel._simpleDropdownHideTimer);
        panel._simpleDropdownHideTimer = null;
      }
      panel.setAttribute('aria-hidden', 'true');
      panel._simpleDropdownHideTimer = trackTimeout(function () {
        if (!item.classList.contains('is-open')) {
          if (typeof panel.hidePopover === 'function' && panel.matches(':popover-open')) {
            panel.hidePopover();
          }
          panel.style.removeProperty('--nav-dropdown-block-start');
          panel.style.removeProperty('--nav-dropdown-inline-start');
        }
        panel._simpleDropdownHideTimer = null;
      }, desktopDropdownDuration);
    }

    function showDesktopDropdownPanels(item) {
      showSimpleDesktopDropdown(item);
      getDesktopDropdownPanels(item).forEach(function (panel) {
        if (panel._desktopDropdownHideTimer) {
          clearTrackedTimeout(panel._desktopDropdownHideTimer);
          panel._desktopDropdownHideTimer = null;
        }
        panel.hidden = false;
        if (typeof panel.showPopover === 'function' && !panel.matches(':popover-open')) {
          panel.showPopover();
        }
        panel.setAttribute('aria-hidden', 'false');
      });
    }

    function hideDesktopDropdownPanels(item) {
      hideSimpleDesktopDropdown(item);
      getDesktopDropdownPanels(item).forEach(function (panel) {
        if (panel._desktopDropdownHideTimer) {
          clearTrackedTimeout(panel._desktopDropdownHideTimer);
          panel._desktopDropdownHideTimer = null;
        }
        panel.setAttribute('aria-hidden', 'true');
        panel._desktopDropdownHideTimer = trackTimeout(function () {
          var owner = panel.closest('.nav-links__item--has-dropdown');
          if (!owner || !owner.classList.contains('is-open')) {
            if (typeof panel.hidePopover === 'function' && panel.matches(':popover-open')) {
              panel.hidePopover();
            }
            panel.hidden = true;
          }
          panel._desktopDropdownHideTimer = null;
        }, desktopDropdownDuration);
      });
    }

    function openDesktopDropdown(item) {
      if (!item) return;

      desktopDropdownItems.forEach(function (other) {
        if (other !== item && other.classList.contains('is-open')) {
          other.classList.remove('is-open');
          clearMegaMenuHoverBridge(other);
          hideDesktopDropdownPanels(other);
          var otherTrigger = other.querySelector('[data-dropdown-trigger]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }
      });

      showDesktopDropdownPanels(item);
      item.classList.add('is-open');
      syncMegaMenuHoverBridge(item);
      revealOpenGroup(item);
      hasOpenDesktopDropdown = true;
      var trigger = item.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      syncHeaderMenuState();
    }

    function closeDesktopDropdown(item) {
      if (!item) return;
      item.classList.remove('is-open');
      clearMegaMenuHoverBridge(item);
      hideDesktopDropdownPanels(item);
      hasOpenDesktopDropdown = Boolean(document.querySelector('.nav-links__item--has-dropdown.is-open'));
      var trigger = item.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      syncHeaderMenuState();
    }

    function closeSearch(options) {
      if (!searchPanel) return;
      options = options || {};

      abortPredictiveRequest();
      if (searchPanel.dataset.scrollLocked === 'true') {
        if (window.Axiom && typeof window.Axiom.unlockPageScroll === 'function') {
          window.Axiom.unlockPageScroll(searchPanel);
        } else {
          document.documentElement.classList.remove('is-scroll-locked');
        }
        delete searchPanel.dataset.scrollLocked;
      }
      searchPanel.classList.remove('is-open');
      searchPanel.classList.remove('search-panel--keyboard-focus');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchPanel.setAttribute('inert', '');
      if (window.Axiom && typeof window.Axiom.releaseFocus === 'function') {
        window.Axiom.releaseFocus(searchPanel);
      }
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.classList.remove('overlay--search-active');
      }
      searchTriggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
      hidePredictiveResults();
      syncHeaderMenuState();
      var restoreTarget = searchTrigger === wideSearchInput ? header.querySelector('.nav-logo') : searchTrigger;
      if (options.restoreFocus && restoreTarget && document.contains(restoreTarget)) {
        restoreTarget.focus({ preventScroll: true });
      }
    }

    function openSearch() {
      if (!searchPanel) return;

      activatePredictiveSearch(searchInput, predictiveForm, predictiveResults);

      closeMobileDrawer({ keepHeaderState: true });
      closeDesktopSidebar({ keepHeaderState: true });
      closeAllDesktopDropdowns();
      syncHeaderHeight();
      headerSticky?.syncPanelOffset(searchPanel);

      searchPanel.classList.add('is-open');
      searchPanel.classList.toggle('search-panel--keyboard-focus', lastInputWasKeyboard);
      searchPanel.setAttribute('aria-hidden', 'false');
      searchPanel.removeAttribute('inert');
      if (window.Axiom && typeof window.Axiom.releaseFocus === 'function') {
        window.Axiom.releaseFocus(searchPanel);
      }
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.classList.add('overlay--search-active');
      }
      if (window.Axiom && typeof window.Axiom.lockPageScroll === 'function') {
        window.Axiom.lockPageScroll(searchPanel);
      } else {
        document.documentElement.classList.add('is-scroll-locked');
      }
      searchPanel.dataset.scrollLocked = 'true';
      searchTriggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', trigger === searchTrigger ? 'true' : 'false'); });
      syncHeaderMenuState();

      if (window.Axiom && typeof window.Axiom.trapFocus === 'function') {
        window.Axiom.trapFocus(searchPanel, { focusTarget: searchInput || undefined });
      } else if (searchInput) {
        searchInput.focus();
      }
    }

    function openMobileDrawer() {
      if (!drawer) return;

      hydrateDeferredContent(
        drawer,
        '[data-mobile-drawer-footer-host]',
        '[data-mobile-drawer-footer-template]'
      );

      closeSearch();
      closeDesktopSidebar({ keepHeaderState: true });
      closeAllDesktopDropdowns();
      closeSidebarPanels(drawer, { immediate: true });
      syncHeaderHeight();
      headerSticky?.syncPanelOffset(drawer);

      if (window.Axiom && typeof window.Axiom.openDrawer === 'function') {
        window.Axiom.openDrawer(drawer, null, {
          autofocus: true,
          focusTarget: drawer.querySelector('[data-drawer-initial-focus]'),
          returnFocus: hamburger,
          trapFocus: true
        });
      } else {
        drawer.hidden = false;
        drawer.removeAttribute('inert');
        window.requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      revealOpenGroup(drawer);
      syncHeaderMenuState();
    }

    function closeMobileDrawer(options) {
      if (!drawer) return;

      options = options || {};
      closeSidebarPanels(drawer, { immediate: true });

      if (window.Axiom && typeof window.Axiom.closeDrawer === 'function') {
        window.Axiom.closeDrawer(drawer);
      } else {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
        if (drawer.hasAttribute('data-drawer-hide-when-closed')) {
          drawer.classList.add('is-closing');
          trackTimeout(function () {
            drawer.classList.remove('is-closing');
            drawer.hidden = true;
          }, panelDuration + 80);
        }
        document.body.style.overflow = '';
      }

      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      if (!options.keepHeaderState) syncHeaderMenuState();
    }

    function openDesktopSidebar() {
      var sidebar = syncDesktopSidebarState(true);
      if (!sidebar) return;

      hydrateDeferredContent(
        sidebar,
        '[data-sidebar-footer-host]',
        '[data-sidebar-footer-template]'
      );

      sidebar.classList.remove('is-settled');
      closeSearch();
      closeMobileDrawer({ keepHeaderState: true });
      closeAllDesktopDropdowns();
      closeSidebarPanels(sidebar, { immediate: true });
      setHeaderPanelPreviewState(true);
      syncHeaderHeight();
      headerSticky?.syncPanelOffset(sidebar);

      document.body.classList.add('desktop-sidebar-open');

      if (window.Axiom && typeof window.Axiom.openDrawer === 'function') {
        window.Axiom.openDrawer(sidebar, null, {
          autofocus: true,
          focusTarget: sidebar.querySelector('[data-drawer-initial-focus]'),
          returnFocus: hamburger,
          trapFocus: true
        });
      } else {
        sidebar.hidden = false;
        sidebar.removeAttribute('inert');
        window.requestAnimationFrame(function () {
          sidebar.classList.add('is-open');
        });
        sidebar.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      revealOpenGroup(sidebar);
      syncHeaderMenuState();
    }

    function closeDesktopSidebar(options) {
      var sidebar = syncDesktopSidebarState();
      if (!sidebar) return;

      options = options || {};
      sidebar.classList.remove('is-settled');
      closeSidebarPanels(sidebar, { immediate: true });
      if (!options.keepHeaderState) {
        setHeaderPanelPreviewState(false);
      }

      if (window.Axiom && typeof window.Axiom.closeDrawer === 'function') {
        window.Axiom.closeDrawer(sidebar);
      } else {
        sidebar.classList.remove('is-open');
        sidebar.setAttribute('aria-hidden', 'true');
        sidebar.setAttribute('inert', '');
        if (sidebar.hasAttribute('data-drawer-hide-when-closed')) {
          sidebar.classList.add('is-closing');
          trackTimeout(function () {
            sidebar.classList.remove('is-closing');
            sidebar.hidden = true;
          }, panelDuration + 80);
        }
        document.body.style.overflow = '';
      }
      document.body.classList.remove('desktop-sidebar-open');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      if (!options.keepHeaderState) syncHeaderMenuState();
    }

    function closeNavigationPanelsForCommerce() {
      closeAllDesktopDropdowns();
      closeDesktopSidebar();
    }

    syncHeaderHeight();
    syncDesktopSidebarState();
    syncHamburgerTarget();

    on(window, 'resize', function () {
      syncHeaderHeight();
      syncDesktopSidebarState();
      syncHamburgerTarget();
      desktopDropdownItems.forEach(function (item) {
        if (item.classList.contains('is-open')) syncMegaMenuHoverBridge(item);
      });
    }, { passive: true });

    searchTriggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      on(trigger, 'click', function () {
        searchTrigger = trigger;
        openSearch();
      });
    });

    if (wideSearchInput) {
      on(wideSearchInput, 'focus', function () {
        activatePredictiveSearch(wideSearchInput, wideSearchForm, widePredictiveResults);
      });
      on(wideSearchInput, 'input', function () {
        if (predictiveTimer) clearTrackedTimeout(predictiveTimer);
        predictiveTimer = trackTimeout(function () {
          fetchPredictiveResults(wideSearchInput.value.trim());
          predictiveTimer = null;
        }, 200);
      });
      on(wideSearchForm, 'focusout', function (event) {
        if (!wideSearchForm.contains(event.relatedTarget)) hidePredictiveResults();
      });
    }

    if (closeSearchBtn) {
      on(closeSearchBtn, 'click', function () { closeSearch({ restoreFocus: true }); });
    }

    if (searchInput && predictiveForm && predictiveForm.dataset.predictiveEnabled === 'true') {
      on(searchInput, 'input', function () {
        if (predictiveTimer) clearTrackedTimeout(predictiveTimer);
        predictiveTimer = trackTimeout(function () {
          fetchPredictiveResults(searchInput.value.trim());
          predictiveTimer = null;
        }, 200);
      });
    }

    on(document, 'keydown', function (event) {
      lastInputWasKeyboard = true;

      if (event.key === 'Tab' && isSearchOpen()) {
        searchPanel.classList.add('search-panel--keyboard-focus');
      }

      if (event.key === 'Escape' && document.querySelector('.stories-viewer.is-open')) return;

      if (event.key === 'Escape' && isSearchOpen()) {
        closeSearch({ restoreFocus: true });
      } else if (event.key === 'Escape' && widePredictiveResults && widePredictiveResults.classList.contains('is-visible')) {
        hidePredictiveResults();
        wideSearchInput.focus({ preventScroll: true });
      } else if (event.key === 'Escape' && isDesktopSidebarOpen()) {
        closeDesktopSidebar();
      } else if (event.key === 'Escape' && isMobileDrawerOpen()) {
        closeMobileDrawer();
      } else if (event.key === 'Escape' && document.querySelector('.nav-links__item--has-dropdown.is-open')) {
        closeAllDesktopDropdowns();
      }
    });

    on(document, 'pointerdown', function () {
      lastInputWasKeyboard = false;
      if (searchPanel) searchPanel.classList.remove('search-panel--keyboard-focus');
    }, { passive: true });

    if (hamburger) {
      on(hamburger, 'click', function () {
        if (usesSidebar()) {
          if (isDesktopSidebarOpen()) {
            closeDesktopSidebar();
          } else {
            openDesktopSidebar();
          }
          return;
        }

        if (isMobileDrawerOpen()) {
          closeMobileDrawer();
        } else {
          openMobileDrawer();
        }
      });
    }

    if (overlay) {
      on(overlay, 'click', function () {
        if (isSearchOpen()) {
          closeSearch();
        }
      });
    }

    if (drawer) {
      on(drawer, 'click', function (event) {
        if (event.target === drawer) closeMobileDrawer();
      });

      drawer.querySelectorAll('[data-mobile-toggle]').forEach(function (button) {
        on(button, 'click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          var sub = button.nextElementSibling;
          if (expanded) {
            closeMobileAccordion(sub);
          } else {
            openMobileAccordion(sub);
          }
        });
      });

      drawer.querySelectorAll('[data-sidebar-panel-open]').forEach(function (button) {
        on(button, 'click', function (event) {
          event.preventDefault();
          openSidebarPanel(drawer, button);
        });
      });

      drawer.querySelectorAll('[data-sidebar-panel-close]').forEach(function (button) {
        on(button, 'click', function () {
          closeSidebarPanels(drawer, { focusTrigger: true });
        });
      });
    }

    bindDesktopSidebarElement(desktopSidebar);

    if (desktopDropdownItems.length > 0) {
      var OPEN_INTENT_DELAY = 50;
      var CLOSE_INTENT_DELAY = 80;

      desktopDropdownItems.forEach(function (item) {
        var openTimer = null;
        var closeTimer = null;

        function clearIntentTimers() {
          clearTrackedTimeout(openTimer);
          clearTrackedTimeout(closeTimer);
          openTimer = null;
          closeTimer = null;
        }

        if (dropdownOpenBehavior === 'hover') {
          on(item, 'mouseenter', function () {
            clearIntentTimers();
            openTimer = trackTimeout(function () {
              openDesktopDropdown(item);
              openTimer = null;
            }, OPEN_INTENT_DELAY);
          });

          on(item, 'mouseleave', function () {
            clearIntentTimers();
            closeTimer = trackTimeout(function () {
              closeDesktopDropdown(item);
              closeTimer = null;
            }, CLOSE_INTENT_DELAY);
          });
        } else {
          var dropdownTrigger = item.querySelector('[data-dropdown-trigger]');
          on(dropdownTrigger, 'click', function (event) {
            if (!item.classList.contains('is-open')) {
              event.preventDefault();
              openDesktopDropdown(item);
            }
          });
        }

        on(item, 'focusin', function () {
          clearIntentTimers();
          openDesktopDropdown(item);
        });

        on(item, 'focusout', function (event) {
          if (!item.contains(event.relatedTarget)) {
            clearIntentTimers();
            closeDesktopDropdown(item);
          }
        });
      });

      on(window, 'scroll', function () {
        if (hasOpenDesktopDropdown) {
          closeAllDesktopDropdowns();
        }
      }, { passive: true });
    }

    on(document, 'click', function (event) {
      if (event.defaultPrevented) return;
      if (event.target.closest('[data-open-cart], [data-cart-drawer-open], [data-quick-view], .quick-view-btn')) {
        closeNavigationPanelsForCommerce();
      }
    });

    function closeMobileAccordion(sub) {
      if (!sub || sub.hidden) return;
      var expandedHeight = sub.scrollHeight;
      sub._accordionState = 'closing';
      sub.style.maxHeight = expandedHeight + 'px';
      trackFrame(function () {
        if (sub._accordionState !== 'closing') return;
        sub.classList.remove('is-open');
        sub.style.maxHeight = '0px';
        trackTimeout(function () {
          if (sub._accordionState === 'closing' && !sub.classList.contains('is-open')) {
            sub.hidden = true;
            sub.style.maxHeight = '';
            delete sub._accordionState;
          }
        }, mobileAccordionDuration);
      });
    }

    function openMobileAccordion(sub) {
      if (!sub) return;
      sub._accordionState = 'opening';
      sub.hidden = false;
      sub.style.maxHeight = '0px';
      trackFrame(function () {
        trackFrame(function () {
          if (sub._accordionState !== 'opening') return;
          var expandedHeight = sub.scrollHeight;
          sub.classList.add('is-open');
          sub.style.maxHeight = expandedHeight + 'px';
          trackTimeout(function () {
            if (sub._accordionState === 'opening' && sub.classList.contains('is-open')) {
              sub.style.maxHeight = 'none';
              delete sub._accordionState;
            }
          }, mobileAccordionDuration);
        });
      });
    }

    return {
      header: header,
      syncSidebar: function () {
        syncDesktopSidebarState();
        syncHamburgerTarget();
        syncHeaderMenuState();
      },
      destroy: function () {
        if (predictiveTimer) {
          clearTrackedTimeout(predictiveTimer);
          predictiveTimer = null;
        }
        abortPredictiveRequest();

        closeAllDesktopDropdowns();
        closeSearch();
        closeMobileDrawer({ keepHeaderState: true });
        closeDesktopSidebar({ keepHeaderState: true });
        document.body.classList.remove('desktop-sidebar-open');
        clearAllTrackedFrames();
        clearAllTrackedTimeouts();
        if (desktopSidebar) {
          delete desktopSidebar.dataset.headerSidebarBound;
        }

        cleanups.forEach(function (cleanup) {
          cleanup();
        });
        cleanups = [];
        if (headerSticky && typeof headerSticky.destroy === 'function') {
          headerSticky.destroy();
          if (header._axiomStickyController === headerSticky) delete header._axiomStickyController;
          headerSticky = null;
        }
      }
    };
  }

  initAxiomHeader(document);

  function syncHeaderSidebarAfterSectionChange(event) {
    window.requestAnimationFrame(function () {
      var target = event && event.target ? event.target : document;
      var selector = '[data-header], [data-desktop-sidebar]';
      var affectsHeader = Boolean(
        target
        && (
          (typeof target.matches === 'function' && target.matches(selector))
          || (typeof target.querySelector === 'function' && target.querySelector(selector))
        )
      );

      initAxiomHeader(target, affectsHeader);
      if (headerInstance && typeof headerInstance.syncSidebar === 'function') {
        headerInstance.syncSidebar();
      }
    });
  }

  document.addEventListener('shopify:section:load', syncHeaderSidebarAfterSectionChange);
  document.addEventListener('shopify:section:unload', syncHeaderSidebarAfterSectionChange);
  document.addEventListener('shopify:section:select', syncHeaderSidebarAfterSectionChange);
  document.addEventListener('shopify:section:deselect', syncHeaderSidebarAfterSectionChange);
  document.addEventListener('shopify:section:reorder', syncHeaderSidebarAfterSectionChange);
})();
